import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Routes } from '@angular/router';
import { FeatureFlags, FrontendPermissions } from '@vierkant-software/types__api';
import { AuthGuard } from 'src/services/auth.guard';
import { LoadGuard } from 'src/services/load.guard';
import { additional_routes } from './app-routing.module.dev';
import { InternalAppService } from 'src/services/app.service';

const modalRoutes = ['calendar', 'absence/modal', 'credentials', 'contract-employee',
'demo', 'users', 'person', 'exit', 'time-correction-profile', 'absence-credit-account','user-self-service', 'user-time-account','projects',
'user-document', "person-shift",'eAU-request','datev-connection-edit', 'bank-account', 'geo-zone','attendance-project-edit',
'assign-member-contract', 'member-contract-template', 'resource', 'edit-debtor-sub-account',
'rest-time-reason', 'rest-time', 'rest-time-cancel', 'user-custom-fields']; //NEW explain

const routes: Routes = [
  {
    path:         '',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardPageModule),
    pathMatch:    'full',
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.loginAdmin],
    },
  },
  ...additional_routes,
  // {
  //   path:         'contract',
  //   loadChildren: () => import('./pages/contract/contract.module').then(m => m.ContractPageModule),
  //   canActivate:  [AuthGuard],
  //   data:         {
  //     permissions: [FrontendPermissions.memberContractTemplates_view],
  //   },
  // },
  {
    path:         'member-contract-template-overview',
    loadChildren: () => import('./pages/contract-member/contract-template-overview/contract-template-overview.module')
      .then(m => m.ContractTemplateOverviewPageModule),
    canActivate: [AuthGuard],
    data:        {
      permissions: [FrontendPermissions.memberContractTemplates_view],
    },
  },
  {
    path:         'member-contract-template',
    loadChildren: () => import('./steppers/contract-members/contract-template/contract-member.module').then(m => m.ContractMemberModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.memberContractTemplates_edit],
    },
  },
  {
    path:         'assign-member-contract',
    loadChildren: () => import('./steppers/contract-members/assign-contract/contract-member.module').then(m => m.AssignContractMemberModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.loginAdmin],
	    feature:     FeatureFlags.create_member_contract,
    },
  },
  {
    //Member-Permissions-Stepper
    path:         'member-permissions',
    loadChildren: () => import('./steppers/member-permissions/member-permissions.module').then(m => m.MemberPermissionsModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.memberPermissions_edit],
    },
  },
  {
    //Cancellation-Reason-Stepper
    path:         'cancellation-reason',
    loadChildren: () => import('./steppers/cancellation-reasons/cancellation-reasons.module').then(m => m.CancellationReasonsModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.loginAdmin],
    },
  },
  {
    //Cancellation-Reason-Page
    path:         'cancellation-reasons',
    loadChildren: () => import('./pages/cancellation-reasons/cancellation-reasons.module').then(m => m.CancellationReasonsPageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.loginAdmin],
    },
  },
  {
    path:         'calendar',
    loadChildren: () => import('./modules/calendar/calendar.page.module').then(m => m.CalendarPageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.loginAdmin],
    },
  },

  //--- Overview-Pages & associated steppers
  {
    //Settings-documents-page
    path:         'directory-overview',
    loadChildren: () => import('./pages/documents/documents.module').then(m => m.DocumentsModule),
    canActivate:  [AuthGuard],
    data:         {
        reuseRoute:  true,
        permissions: [FrontendPermissions.documents_view],  // FIXME proper permission
    }
  },
  {
    path:         'new-directory',
    loadChildren: () => import('./steppers/documents/documents.module').then(m => m.DocumentsStepperModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.documents_edit],  // FIXME proper permission
    }
  },
  {
    //Studio-documents-overview-page
    path:         'studio-documents',
    loadChildren: () => import('./pages/studio-documents/studio-documents.module').then(m => m.StudioDocumentsModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.createDocuments_view],
    }
  },
  {
    //Studio-document-stepper
    path:         'studio-document',
    loadChildren: () => import('./steppers/studio-document/studio-document.module').then(m => m.StudioDocumentModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.createDocuments_edit],
    }
  },
  {
    //Special-days-overview-page
    path:         'special-days',
    loadChildren: () => import('./pages/special-days/special-days.module').then(m => m.SpecialDaysPageModule),
    canActivate:  [AuthGuard],
    data:         {
        permissions: [FrontendPermissions.holidays_view]
    }
  },
  {
    //Special-day-template stepper
    path:         'special-day-template',
    loadChildren: () => import('./steppers/special-day-template/special-day-template.module').then(m => m.SpecialDayTemplateStepperModule),
    canActivate:  [AuthGuard],
    data:         {
        permissions: [FrontendPermissions.holidays_edit]
    }
  },
  {
    //Special-day stepper
    path:         'special-day',
    loadChildren: () => import('./steppers/special-day/special-day.module').then(m => m.SpecialDayStepperModule),
    canActivate:  [AuthGuard],
    data:         {
        permissions: [FrontendPermissions.holidays_edit]
    }
  },
  {
    //Business-hours overview settings page
    path:         'settings-opening-times',
    loadChildren: () => import('./pages/business-hours/business-hours.module').then(m => m.BusinessHoursPageModule),
    canActivate:  [AuthGuard],
    data:         {
        permissions: [FrontendPermissions.openingTimes_edit]
    }
  },
  {
    //Business-hours-edit stepper
    path:         'business-hours',
    loadChildren: () => import('./steppers/business-hours/business-hours.module').then(m => m.BusinessHoursStepperModule),
    canActivate:  [AuthGuard],
    data:         {
        permissions: [FrontendPermissions.openingTimes_edit]
    }
  },
  {
    //Alternative-business hours stepper
    path:         'alternative-business-hours',
    loadChildren: () => import('./steppers/alternative-business-hours/alternative-business-hours.module').then(m => m.AlternativeBusinessHoursStepperModule),
    canActivate:  [AuthGuard],
    data:         {
        permissions: [FrontendPermissions.openingTimes_edit]
    }
  },
  {
    // workflow-overview page
    path:         'workflow',
    loadChildren: () => import('./workflows/workflows.module').then(m => m.WorkflowsPageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.loginAdmin],
      feature:     FeatureFlags.workflow,
    },
  },
  {
    // Time-correctoin-page
    path:         'time-corrections',
    loadChildren: () => import('./pages/time-corrections/time-corrections.module').then(m => m.TimeCorrectionsPageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.loginAdmin, FrontendPermissions.timeCorrections_edit],
    },
  },
  //FIXME Rename remove profile
  {
    //Time correction stepper (in stats & checkin/time-correction)
    path:         'time-correction-profile',
    loadChildren: () => import('./steppers/time-correction/time-correction.module').then(m => m.TimeCorrectionModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.timeCorrections_edit],
    },
  },
  {
    //Check-in Area stepper
    path:         'check-in-areas',
    loadChildren: () => import('./steppers/check-in-areas/check-in-areas.module').then(m => m.CheckInAreasModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.checkInArea_edit],
    },
  },
  {
    //Check-in Area stepper
    path:         'check-in-areas-overview',
    loadChildren: () => import('./pages/check-in-areas/check-in-areas.module').then(m => m.CheckInAreasPageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.checkInArea_view],
    },
  },
  {
    //Time-tracking-set-overview
    path:         'time-tracking',
    loadChildren: () => import('./pages/time-tracking/time-tracking.module').then(m => m.TimeTrackingPageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.loginAdmin, FrontendPermissions.timeTrackingSets_view],
    },
  },
  {
    //Time Tracking stepper
    path:         'time-tracking-profile',
    loadChildren: () => import('./steppers/time-tracking/time-tracking.module').then(m => m.TimeTrackingModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.timeTrackingSets_edit],
    },
  },
  {
    //Time Tracking Individual stepper
    path:         'time-tracking-profile-individual',
    loadChildren: () => import('./steppers/time-tracking-individual/time-tracking.module').then(m => m.TimeTrackingModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.employeeContracts_edit],
    },
  },
  //FIXME @jens, chris rename to permission-groups-overview
  {
    // Permission groups overview
    path:         'permission-groups',
    loadChildren: () => import('./pages/permission-groups/permission-groups-overview.module').then(m => m.PermissionGroupsOverviewPageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.permissionGroups_view],
    },
  },
  {
    // Permission groups Stepper
    path:         'permission-groups',
    loadChildren: () => import('./steppers/permission-groups/permission-groups.module').then(m => m.GroupsModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.permissionGroups_edit],
    },
  },
  {
    //employee contract template overview (not gymcore)
    path:         'employee-contract-template-overview',
    loadChildren: () => import('./pages/contracts-employee/overview/employee-overview.module').then(m => m.EmployeeOverviewPageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.loginAdmin, FrontendPermissions.employeeContractTemplates_view],
    },
  },
  {
    // EmployeeContract template stepper
    path:         'employee-contract-template',
    loadChildren: () => import('./steppers/employee-contract-template/employee-contract-template.module').then(m => m.EmployeeContractTemplateModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.employeeContractTemplates_edit],
    }
  },
  {
    path:         'online-contract-overview',
    loadChildren: () => import('./pages/online-contract/online-contract-overview.module').then(m => m.OnlineContractOverviewModule),
	  canActivate:  [AuthGuard],
	  data:         {
		  permissions: [FrontendPermissions.memberContractSelfService_view]
	  }
  },
  {
    path:         'online-contract',
    loadChildren: () => import('./steppers/online-contract/online-contract.module').then(m => m.OnlineContractModule),
	  canActivate:  [AuthGuard],
	  data:         {
		  permissions: [FrontendPermissions.memberContractSelfService_edit]
	  }
  },
  {
    // Product Management Pages
    path:         'product-management',
    loadChildren: () => import('./pages/product-management/product-management.module').then(m => m.ProductManagementModule),
    canActivate:  [AuthGuard],
    data:         {
        permissions: [FrontendPermissions.product_view]
    }
  },
  {
    // Product stepper
    path:         'product',
    loadChildren: () => import('./steppers/product-management/product/product.module').then(m => m.ProductModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.product_edit],
    },
  },
  {
    // Product-Category stepper
    path:         'product-category',
    loadChildren: () => import('./steppers/product-management/product-category/product-category.module').then(m => m.ProductCategoryModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.product_edit],
    },
  },
  {
    // Product-Categories overview page
    path:         'product-categories',
    loadChildren: () => import('./pages/product-management/product-categories/product-categories.module').then(m => m.ProductCategoriesPageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.product_view],
    },
  },
  {
    // Org Chart Overview
    path:         'org-chart',
    loadChildren: () => import('./pages/org-chart/org-chart.module').then(m => m.OrgChartModule),
    canActivate:  [AuthGuard],
    data:         {
        reuseRoute:  true,
        permissions: [FrontendPermissions.orgCharts_view],
    }
  },
  {
    // Org Chart stepper
    path:         'org-chart-edit',
    loadChildren: () => import('./steppers/org-chart/org-chart.module').then(m => m.OrgChartStepperModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.orgCharts_edit],
    }
  },
  //FIXME rename to absence-types-overview
  {
    //Absence types overview
    path:         'absence-types',
    loadChildren: () => import('./pages/absence/absence-types/absence-types.module').then(m => m.AbsenceTypesPageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.absenceTypes_view],
    }
  },
  //FIXME rename to absence-types
  {
    //Absence types stepper
    path:         'new-absence-types',
    loadChildren: () => import('./steppers/absence-types/absence-types.module').then(m => m.AbsenceTypesModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.absenceTypes_edit],
    }
  },
  {
    //Workflows stepper
    path:         'workflows',
    loadChildren: () => import('./steppers/workflows/workflows.module').then(m => m.WorkflowsModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.workflowDefaults_edit],
    }
  },
  {
    //Projects overview page
    path:         'projects-overview',
    loadChildren: () => import('./pages/projects/overview/projects-overview.module').then(m => m.ProjectsOverviewPageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.projects_view],
    }
  },
  {
    //Projet Stepper
    path:         'project',
    loadChildren: () => import('./steppers/projects/project.module').then(m => m.ProjectModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.projects_edit],
    }
  },
  {
    // Surcharge overview page
    path:         'surcharge-overview',
    loadChildren: () => import('./pages/surcharge/overview/surcharge-overview.module').then(m => m.SurchargeOverviewPageModule),
    canActivate:  [AuthGuard],
    data:         {
        permissions: [FrontendPermissions.surcharge_view],
    }
  },
  {
    // Surcharge stepper
    path:         'surcharge-stepper',
    loadChildren: () => import('./steppers/surcharge/surcharge.module').then(m => m.SurchargeModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.surcharge_edit],
    },
  },
  {
      path:         'calendar-preset',
      loadChildren: () => import('./steppers/calendar-preset/calendar-preset.module').then(m => m.CalendarPresetModule),
      canActivate:  [AuthGuard],
      data:         {
          permissions: [FrontendPermissions.calendar_edit],
          feature:     FeatureFlags.calendar
      }
  },
  {
    // Resource-types stepper
    path:         'resource-type',
    loadChildren: () => import('./steppers/resource-type/resource-type.module').then(m => m.ResourceTypeModule),
    canActivate:  [AuthGuard],
    data:         {
        permissions: [FrontendPermissions.calendar_edit],
    }
  },
  {
    // Resource stepper
    path:         'resource',
    loadChildren: () => import('./steppers/resource/resource.module').then(m => m.ResourceModule),
    canActivate:  [AuthGuard],
    data:         {
        permissions: [FrontendPermissions.calendar_edit],
    }
  },
  {
    path:         'self-service',
    loadChildren: () => import('./pages/self-service/self-service.module').then(m => m.SelfServicePageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.calendar_edit],
    }
  },
  {
    // Self-Service-Config stepper
    path:         'self-service-config',
    loadChildren: () => import('./steppers/self-service-config/self-service-config.module').then(m => m.SelfServiceConfigModule),
    canActivate:  [AuthGuard],
    data:         {
        permissions: [FrontendPermissions.calendar_edit],
    }
  },
  {
    // Terminals overview page
    path:         'terminals-overview',
    loadChildren: () => import('./pages/terminals/overview/terminals-overview.module').then(m => m.TerminalsOverviewPageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.terminals_view],
    }
  },
  {
    //Terminals stepper
    path:         'terminal',
    loadChildren: () => import('./steppers/terminal/terminal.module').then(m => m.TerminalModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.terminals_edit],
    },
  },
  {
    // Geo-Zones page
    path:         'geo-zones',
    loadChildren: () => import('./pages/geo-zones/geo-zones.module').then(m => m.GeoZonesPageModule),
    canActivate:  [AuthGuard],
    data:         {
        permissions: [FrontendPermissions.holidays_view],
    }
  },
  {
    //Geo-Zone stepper
    path:         'geo-zone',
    loadChildren: () => import('./steppers/geo-zone/geo-zone.module').then(m => m.GeoZoneStepperModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.holidays_edit],
    },
  },
  {
    // Auszeit-Gründe page
    path:         'rest-time-reasons',
    loadChildren: () => import('./pages/rest-time-reasons/rest-time-reasons.module').then(m => m.RestTimeReasonsPageModule),
    canActivate:  [AuthGuard],
    data:         {
        permissions: [FrontendPermissions.restTimeReasons_view],
    }
  },
  {
    //Auszeit-Grund stepper
    path:         'rest-time-reason',
    loadChildren: () => import('./steppers/rest-time-reason/rest-time-reason.module').then(m => m.RestTimeReasonModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.restTimeReasons_edit],
    },
  },
  {
    // Drucker page
    path:         'printers',
    loadChildren: () => import('./pages/printers/printers.module').then(m => m.PrintersPageModule),
    canActivate:  [AuthGuard],
    data:         {
        permissions: [FrontendPermissions.printer_view],
    }
  },
  {
    // Drucker stepper
    path:         'printer',
    loadChildren: () => import('./steppers/printer/printer.module').then(m => m.PrinterStepperModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.printer_edit],
    },
  },
  {
    // Auszeit-Sets page
    path:         'rest-time-sets',
    loadChildren: () => import('./pages/rest-time-sets/rest-time-sets.module').then(m => m.RestTimeSetsPageModule),
    canActivate:  [AuthGuard],
    data:         {
        permissions: [FrontendPermissions.restTimeSets_view],
    }
  },
  {
    //Auszeit-Set stepper
    path:         'rest-time-set',
    loadChildren: () => import('./steppers/rest-time-set/rest-time-set.module').then(m => m.RestTimeSetModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.restTimeSets_edit],
    },
  },
  {
    //Auszeit-Anlage/-Bearbeiten stepper (dasselbe Formular wird per RecordID auch fürs Bearbeiten geöffnet)
    path:         'rest-time',
    loadChildren: () => import('./steppers/rest-time/rest-time.module').then(m => m.RestTimeModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.personRestTimes_add, FrontendPermissions.personRestTimes_edit],
    },
  },
  {
    //Auszeit-Storno stepper
    path:         'rest-time-cancel',
    loadChildren: () => import('./steppers/rest-time-cancel/rest-time-cancel.module').then(m => m.RestTimeCancelModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.personRestTimes_cancel],
    },
  },
  {
    //Transfer-Credit page
    path:         'absence-credit-transfer',
    loadChildren: () => import('./pages/absence/transfer-credit/absence-credit-transfer.module').then(m => m.AbsenceCreditTransferPageModule),
    canActivate:  [AuthGuard],
    data:         {
        permissions: [FrontendPermissions.absenceAccountTransfer_edit],
      },
  },
  {
    //Credit-Expiration page
    path:         'absence-credit-expiration',
    loadChildren: () => import('./pages/absence/credit-expiration/absence-credit-expiration.module').then(m => m.AbsenceCreditExpirationPageModule),
    canActivate:  [AuthGuard],
    data:         {
        permissions: [FrontendPermissions.absenceAccountExpiry_edit],
      },
  },
  {
    // DATEV
    path:         'datev',
    loadChildren: () => import('./pages/datev/datev-page.module').then(m => m.DatevPageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.datev_edit,FrontendPermissions.datev_hr_eAU],
      feature:     FeatureFlags.datev
    }
  },
  {
    //DATEV connection edit
    path:         'datev-connection-edit',
    loadChildren: () => import('./steppers/datev-connection-edit/datev-connection-edit.module').then(m => m.DatevConnectionEditModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.datev_edit],
      feature:     FeatureFlags.datev
    },
  },
  {
    //DATEV eAU request
    path:         'eAU-request',
    loadChildren: () => import('./steppers/eAU-request/eAU-request.module').then(m => m.eAURequestModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.datev_hr_eAU],
      feature:     FeatureFlags.datev_hr_eau
    },
  },

  //--- Steppers menu
  {
    path:         'users',
    loadChildren: () => import('./steppers/users/users.module').then(m => m.UsersModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.employeeContracts_edit,FrontendPermissions.personBaseData_edit],
    },
  },
  {
    // Bank-account stepper. A substep used within users' stepper.
    path:         'bank-account',
    loadChildren: () => import('./steppers/bank-account/bank-account.module').then(m => m.BankAccountStepperModule),
    canActivate:  [AuthGuard],
    data:         {
        permissions: [FrontendPermissions.employeeContracts_edit,FrontendPermissions.personBaseData_edit],
        feature:     FeatureFlags.memberbox
    },
  },
  {
    path:         'contract-employee',
    loadChildren: () => import('./steppers/contract-employee/contract-employee.module').then(m => m.ContractEmployeeModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.employeeContracts_edit],
    },
  },
  {
    path:         'company-settings',
    loadChildren: () => import('./steppers/company-settings/company-settings.module').then(m => m.CompanySettingsModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.companySettings_edit],
    },
  },
  {
    path:         'contract-print',
    loadChildren: () => import('./steppers/contract-print/contract-print.module').then(m => m.ContractPrintModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.memberContractPrintSettings_edit],
      feature:     FeatureFlags.memberbox,
    },
  },
  {
    path:         'custom-field-config',
    loadChildren: () => import('./steppers/custom-field-config/custom-field-config.module').then(m => m.CustomFieldConfigModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.userCustomFields_edit],
    },
  },
  {
    path:         'user-custom-fields',
    loadChildren: () => import('./steppers/user-custom-fields/user-custom-fields.module').then(m => m.UserCustomFieldsModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.userCustomFieldValues_edit],
    },
  },
  {
    //Studio settings stepper (Company-settings)
    path:         'studio-settings',
    loadChildren: () => import('./steppers/studio-settings/studio-settings.module').then(m => m.StudioSettingsModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.companySettings_edit],
    },
  },


  //--- person-profile
  {
    path:         'person',
    loadChildren: () => import('./pages/person/person.module').then(m => m.PersonModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.loginAdmin],
    },
  },

  //--- steppers person-profile
  {
    // User OTV/self-service
    path:         'user-self-service',
    loadChildren: () => import('./steppers/user-self-service/user-self-service.module').then(m => m.UserSelfServiceModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.personBaseData_edit],
    },
  },
  {
    //Time account edit
    path:         'user-time-account',
    loadChildren: () => import('./steppers/user-time-account/user-time-account.module').then(m => m.TimeAccountModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.employeeTimeAccounts_edit],
    },
  },
  {
    //credentials-stepper in person-profile
    path:         'credentials',
    loadChildren: () => import('./steppers/credentials/credentials.module').then(m => m.CredentialsModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.loginAdmin],
    },
  },
  {
    // absence credit account stepper - edit
    path:         'absence-credit-account',
    loadChildren: () => import('./steppers/absence-credit-account/absence-credit-account.module').then(m => m.AbsenceCreditAccountModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.absenceOverview_edit],
    },
  },
  {
    // user-document page
    path:         'user-document',
    loadChildren: () => import('./steppers/user-document/user-document.module').then(m => m.UserDocumentStepperModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.personDocuments_view],  // FIXME proper permission
    }
  },
  {
    // person-shift - edit
    path:         'person-shift',
    loadChildren: () => import('./steppers/person-shift/person-shift.module').then(m => m.PersonShiftModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.personShiftplan_edit],
    }
  },


  //--- Pages menu
  {
    // has permission in child-routes
    path:         'analyses',
    loadChildren: () => import('./pages/analyses/analyses-page.module').then(m => m.AnalysesPageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.loginAdmin],
    },
  },
  {
    //Absence Statistics selection
    path:         'absence-selection',
    loadChildren: () => import('./pages/analyses/absences/absence-selection.module').then(m => m.AbsenceSelectionPageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.absenceStats_view],
    }
  },
  {
    //Salary Statistics selection
    path:         'salaries',
    loadChildren: () => import('./pages/analyses/salaries/salaries.module').then(m => m.SalariesPageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.salaryStats_View],
    }
  },
  {
    //Attence overview page
    path:         'attendance-overview',
    loadChildren: () => import('./pages/attendance/attendance-overview.module').then(m => m.AttendancePageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.attendanceList_view],
    }
  },
  {
    //vat rate overview page
    path:         'vat-rate-overview',
    loadChildren: () => import('./pages/cashflow/vat-rate/overview/vat-rate-overview.module').then(m => m.VatRateOverviewPageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.cashflowSettings_view],
    }
  },
  {
    //vat rate stepper
    path:         'vat-rate',
    loadChildren: () => import('./steppers/cashflow/vat-rate/vat-rate.module').then(m => m.VatRateModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.cashflowSettings_edit],
    },
  },
  {
    //accounting account overview page
    path:         'accounting-account-overview',
    loadChildren: () => import('./pages/cashflow/accounting-account/overview/accounting-account-overview.module').then(m => m.AccountingAccountPageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.cashflowSettings_view],
    }
  },
  {
    //accounting account stepper
    path:         'accounting-account',
    loadChildren: () => import('./steppers/cashflow/accounting-account/accounting-account.module').then(m => m.AccountingAccountModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.cashflowSettings_edit],
    },
  },
  {
    //accounting settings stepper
    path:         'accounting-settings',
    loadChildren: () => import('./steppers/accounting-settings/accounting-settings.module').then(m => m.AccountingSettingsModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.cashflowSettings_edit],
	    feature:     FeatureFlags.bookkeeping
    },
  },
  {
    //bank account overview page
    path:         'bank-account-overview',
    loadChildren: () => import('./pages/cashflow/bank-account/bank-account.module').then(m => m.BankAccountPageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.cashflowSettings_view],
    }
  },
  {
    //ebics access points page
    path:         'ebics-contacts-overview',
    loadChildren: () => import('./pages/cashflow/ebics-contacts/ebics-contacts.module').then(m => m.EbicsContactsPageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.cashflowSettings_view],
	    feature:     FeatureFlags.ebics
    }
  },
  {
    path:         'ebics-contact',
    loadChildren: () => import('./steppers/ebics-contact/ebics-contact.module').then(m => m.EbicsContactModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.cashflowSettings_edit],
	    feature:     FeatureFlags.ebics
    },
  },
  {
    //bank account stepper
    path:         'bank-account',
    loadChildren: () => import('./steppers/cashflow/bank-account/bank-account.module').then(m => m.BankAccountModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.cashflowSettings_edit],
    },
  },
	{
		//edit debtor sub-account stepper (modal)
		path:         'edit-debtor-sub-account',
		loadChildren: () => import('./steppers/cashflow/edit-debtor-sub-account/edit-debtor-sub-account.module').then(m => m.EditDebtorSubAccountModule),
		canActivate:  [AuthGuard],
		data:         {
			permissions: [FrontendPermissions.memberFinance_edit],
		},
	},
  {
    //direct debit group overview page
    path:         'direct-debit-group-overview',
    loadChildren: () => import('./pages/cashflow/direct-debit-group/direct-debit-group.module').then(m => m.DirectDebitGroupPageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.cashflowSettings_view],
    }
  },
   {
    //direct debit group stepper
    path:         'direct-debit-group',
    loadChildren: () => import('./steppers/cashflow/direct-debit-group/direct-debit-group.module').then(m => m.DirectDebitGroupModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.cashflowSettings_view],
    }
  },
  {
    //direct debit runs page
    path:         'direct-debit-runs',
    loadChildren: () => import('./pages/cashflow/direct-debit-list/direct-debit-list.module').then(m => m.DirectDebitListPageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.directDebitRun_view],
	    feature:     FeatureFlags.create_direct_debit_run,
    }
  },
  {
    //Account Statements page
    path:         'account-statements',
    loadChildren: () => import('./pages/cashflow/account-statements/account-statements.module').then(m => m.AccountStatementsPageModule),
    canActivate:  [AuthGuard],
    data:         {
      reuseRoute:  true,
      permissions: [FrontendPermissions.accountStatements_View],
	    feature:     FeatureFlags.bank_statements,
    }
  },
  {
    path:          'privacy-policy',
    loadComponent: () => import('./standalone/privacy-policy/privacy-policy.page').then(p => p.PrivacyPolicyPage),
  },
  {
    path:          'something-went-wrong',
    loadComponent: () => import('./standalone/error/error.page').then(p => p.ErrorPage),
    canActivate:   [AuthGuard],
    data:          {
      permissions: [FrontendPermissions.loginAdmin],
    },
  },
  {
    path:          'version-to-old',
    loadComponent: () => import('./standalone/version-to-old/version-to-old.page').then(p => p.VersionToOldPage),
  },
  {
    path:          'maintenance',
    loadComponent: () => import('./standalone/maintenance/maintenance.page').then(p => p.MaintenancePage),
  },
  {
    path:          'exit',
    loadComponent: () => import('./draft-system/components/draft-exit.page').then(c => c.DraftExitPage),
    canActivate:   [AuthGuard],
    data:          {
      permissions: [FrontendPermissions.loginAdmin],
    },
  },
  {
    path:          'exit-animated',
    loadComponent: () => import('./draft-system/components/draft-exit.page').then(c => c.DraftExitPage),
    canActivate:   [AuthGuard],
    data:          {
      isCalm:      false,
      permissions: [FrontendPermissions.loginAdmin]
    },
  },
  //FIXME can be removed whenever there is time to check if its still in use
  {
    path:          'empty',
    loadComponent: () => import('./standalone/empty/empty.page').then(m => m.EmptyPage)
  },
  //--- Steppers somewhere
  {
    //FIXME @jens, @chris, @rene - path
    //Modal step in e.g. absence overview
    path:         'absence/modal',
    loadChildren: () => import('./steppers/absence/absence.module').then(m => m.AbsenceStepperModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.absenceOverview_edit],
    }
  },
  {
    //attendance project edit stepper (in stats)
    path:         'attendance-project-edit',
    loadChildren: () => import('./steppers/attendance/attendance-project-edit/attendance-project-edit.module').then(m => m.AttendanceProjectEditModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.timeCorrections_edit],
    },
  },

  //FIXME remove ?? check if its linked properly
  // {
  //   path:          'not-found-404',
  //   loadComponent: () => import('./standalone/404/not-found.page').then(p => p.NotFoundPage),
  //   canActivate:   [AuthGuard],
  //   data:          {
  //     permissions: [Permission.App_Login_Frontend],
  //   },
  // },

  {
    // MCP
    path:          'session/:studio/:sessionID',
    loadComponent: () => import('./standalone/empty/empty.page').then(m => m.EmptyPage),
    resolve:       {
      A: (route: ActivatedRouteSnapshot) => inject(InternalAppService).__activateSession(route.params.studio, route.params.sessionID)
    }
  },
  {
    // MCP data import
    path:         'import',
    loadChildren: () => import('./pages/import/import.module').then(m => m.ImportModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.ClusterAdmin],
    },
  },
  {
    path:         'check-in-areas',
    loadChildren: () => import('./pages/check-in-areas/check-in-areas.module').then(m => m.CheckInAreasPageModule)
  },
  {
    // Member Check-in stepper
    path:         'member-check-in',
    loadChildren: () => import('./pages/member-check-in/member-check-in.module').then(m => m.MemberCheckInPageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.memberCheckin_view],
	    feature:     FeatureFlags.member_attendance,
    },
  },
  {
    // Checkout Areas Overview Pages
    path:         'checkout-areas-overview',
    loadChildren: () => import('./pages/checkout-areas/overview/checkout-areas-overview.module').then(m => m.CheckoutAreasPageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.checkOutAreaRegister_manage],
	    feature:     FeatureFlags.cashbox
    }
  },
  {
    // Checkout Area stepper
    path:         'checkout-area',
    loadChildren: () => import('./steppers/checkout-areas/checkout-areas.module').then(m => m.CheckoutAreaModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.checkOutAreaRegister_manage],
	    feature:     FeatureFlags.cashbox
    }
  },
  {
    // Cash Registers Overview Pages
    path:         'cash-registers-overview',
    loadChildren: () => import('./pages/cash-registers/overview/cash-registers-overview.module').then(m => m.CashRegistersPageModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.checkOutAreaRegister_manage],
	    feature:     FeatureFlags.cashbox
    }
  },
  {
    // Cash Register stepper
    path:         'cash-register',
    loadChildren: () => import('./steppers/cash-registers/cash-registers.module').then(m => m.CashRegisterModule),
    canActivate:  [AuthGuard],
    data:         {
      permissions: [FrontendPermissions.checkOutAreaRegister_manage],
	    feature:     FeatureFlags.cashbox
    }
  },
	{
		// Shopping cart groups overview
		path:         'shopping-cart-groups-overview',
		loadChildren: () => import('./pages/shopping-cart-groups/shopping-cart-groups.module').then(m => m.ShoppingCartGroupsPageModule),
		canActivate:  [AuthGuard],
		data:         {
			permissions: [FrontendPermissions.tseConfiguration_manage],
		},
	},
	{
		// Shopping cart group stepper
		path:         'shopping-cart-group',
		loadChildren: () => import('./steppers/shopping-cart-group/shopping-cart-group.module').then(m => m.ShoppingCartGroupModule),
		canActivate:  [AuthGuard],
		data:         {
			permissions: [FrontendPermissions.tseConfiguration_manage],
		},
	},
	{
		// fiskaly API key overview
		path:         'tse-api-keys-overview',
		loadChildren: () => import('./pages/tse-api-keys/tse-api-keys.module').then(m => m.TseApiKeysPageModule),
		canActivate:  [AuthGuard],
		data:         {
			permissions: [FrontendPermissions.tseApiKey_manage],
			feature:     FeatureFlags.cashbox,
		},
	},
	{
		// fiskaly API key stepper
		path:         'tse-api-key',
		loadChildren: () => import('./steppers/tse-api-key/tse-api-key.module').then(m => m.TseApiKeyModule),
		canActivate:  [AuthGuard],
		data:         {
			permissions: [FrontendPermissions.tseApiKey_manage],
			feature:     FeatureFlags.cashbox,
		},
	},
	{
		// Number ranges overview
		path:         'number-ranges-overview',
		loadChildren: () => import('./pages/number-ranges/number-ranges.module').then(m => m.NumberRangesPageModule),
		canActivate:  [AuthGuard],
		data:         {
			permissions: [FrontendPermissions.numberRange_view],
		},
	},
	{
		// Number range stepper
		path:         'number-range',
		loadChildren: () => import('./steppers/number-range/number-range.module').then(m => m.NumberRangeModule),
		canActivate:  [AuthGuard],
		data:         {
			permissions: [FrontendPermissions.numberRange_edit],
		},
	},
  { // this have to be the last route entry!
    path:          '**',
    // FIXME @Chris this component changes the default button/dropdown style (blue)
    // and this should be an direct app.component and not lazy loaded anyway
    loadComponent: () => import('./standalone/404/not-found.page').then(p => p.NotFoundPage),
  }
];

routes.forEach(route => {
  if (!route.data)
    route.data = {};

  if (!route.canMatch)
    route.canMatch = [];

  route.canMatch.push(LoadGuard);
  route.data['isCashRegister'] = false;
});

const combinedRoutes = routes.map(x => {
  if (modalRoutes.includes(x.path))
    return [x, {outlet: 'modal', ...x}];
  else return x;
}).flat(1);

export const MemberboxRoutingRoutes: Routes = combinedRoutes;
